import axiosHandler from "../../Intersepter/axiosInstance";

// Fetch tickets API function
export const fetchTickets = async () => {
  try {
    const response = await axiosHandler.get(`/ticket`);
    return response;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

export const purchaseTickets = async (payload) => {
  try {
    const response = await axiosHandler.post(
      `/ticket-purchase/purchase`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error("Network Error");
  }
};

export const fetchPurchaseTicketsByUserId = async (userId) => {
  try {
    const response = await axiosHandler.get(`/ticket-purchase/${userId}`);
    return response.data; // Return the full response data
  } catch (error) {
    // Throw an error for the caller to handle
    throw error.response?.data?.message || error.message;
  }
};

export const fetchAllPurchaseTicketsByUserId = async ({
  userId,
  dateRange,
  start_date,
  end_date,
}) => {
  try {
    // Construct query parameters based on conditions
    let url = `ticket-purchase/all/${userId}`;
    const queryParams = [];

    if (dateRange) queryParams.push(`filter=${dateRange}`);
    if (start_date && end_date)
      queryParams.push(`start_date=${start_date}&end_date=${end_date}`);

    // Append query parameters to the URL if any exist
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    // Perform the API request
    const response = await axiosHandler.get(url);

    console.log("Response:", response.data);
    return response.data; // Return the full response data
  } catch (error) {
    console.error("Error fetching purchase tickets:", error.message);

    // Throw a meaningful error for the caller to handle
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch purchase tickets. Please try again later."
    );
  }
};

export const totalsTicketsAndWinByUserId = async (userId) => {
  try {
    const response = await axiosHandler.get(
      `/ticket-purchase/total_win/${userId}`
    );
    return response.data; // Return the full response data
  } catch (error) {
    // Throw an error for the caller to handle
    throw error.response?.data?.message || error.message;
  }
};
